import {
  getActivationKeyStorageKey,
  getEnabledStorageKey,
} from "./inspectorConfig";

const DEFAULT_INSPECTOR_KEY = "Alt";

export function isComponentInspectorEnabled(): boolean {
  const stored = localStorage.getItem(getEnabledStorageKey());
  if (stored === "enabled") return true;
  if (stored === "disabled") return false;
  // No explicit preference — enabled in dev, disabled in production
  return import.meta.env.DEV;
}

export function setComponentInspectorEnabled(enabled: boolean): void {
  localStorage.setItem(
    getEnabledStorageKey(),
    enabled ? "enabled" : "disabled",
  );
}

export function getInspectorActivationKey(): string {
  return (
    localStorage.getItem(getActivationKeyStorageKey()) ?? DEFAULT_INSPECTOR_KEY
  );
}

export function setInspectorActivationKey(key: string): void {
  localStorage.setItem(getActivationKeyStorageKey(), key);
}
